import { useState } from "react";
import ReactDOM, { createRoot } from 'react-dom/client';
import PasswordField, { IStatePasswordField, InitialStatePasswordField } from "../modules/inputFields/PasswordField";
import CheckBox, { IStateCheckBox, InitialStateCheckBox } from "../modules/inputFields/CheckBox";

import Styles from "../css/UserManagerSignIn.module.css";
import Navigation from "../modules/Navigation";
import { IAutoLogOut } from "./UserManager";
import { IUserData } from "../utils/userManager";

interface TokenAPIResponse {
    status: number
    message: string
    userManagerToken: string
}

function SignIn() {
    const API_URL = process.env.REACT_APP_API_URL;
    const API_TOKEN = window.sessionStorage.getItem("token");

    const userData: IUserData = JSON.parse(window.sessionStorage.getItem("userData") || "");

    const [statePassword, setStatePassword] = useState<IStatePasswordField>(InitialStatePasswordField);
    const [stateAutoLogOut, setStateAutoLogOut] = useState<IStateCheckBox>(InitialStateCheckBox);

    let errorBoxRoot: ReactDOM.Root;

    function onKeyUp(event: any) {
        if (event.keyCode === 13) {
            event.preventDefault()
            signIn()
        }
    }

    async function signIn() {
        let password = statePassword.value;

        const errorBoxContainer = document.getElementById("errorBox");
        if (errorBoxRoot === undefined) {
            errorBoxRoot = createRoot(errorBoxContainer!);
        }

        if (password.length !== 0) {
            const tokenRequestOptions: RequestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${API_TOKEN}`
                },
                body: JSON.stringify({
                    password: password
                }),
                credentials: 'include'
            }

            let tokenResponse: TokenAPIResponse = await fetch(`${API_URL}user/getUserManagerToken.php`, tokenRequestOptions).then(response => response.json());

            if (tokenResponse.status === 200) {
                let autoLogOut: IAutoLogOut | undefined = undefined;

                if (!stateAutoLogOut.checked) {
                    autoLogOut = {
                        active: false,
                        endTimestamp: 0
                    };

                    window.sessionStorage.setItem("userAutoLogOut", JSON.stringify(autoLogOut));
                } else {
                    autoLogOut = {
                        active: true,
                        endTimestamp: new Date(new Date().getTime() + 120000).getTime()
                    };

                    window.sessionStorage.setItem("userAutoLogOut", JSON.stringify(autoLogOut));
                }

                window.sessionStorage.setItem("userManagerToken", tokenResponse.userManagerToken);

                document.location = "/userManager";
            } else if (tokenResponse.status === 401) {
                errorBoxRoot.render(
                    <div id={Styles.errorMessageBox}>
                        <p key="errorMessage">Passwort falsch!</p>
                    </div>
                );
            }
        } else {
            errorBoxRoot.render(
                <div id={Styles.errorMessageBox}>
                    <p key="errorMessage">Es muss ein Passwort eingegeben werden!</p>
                </div>
            );
        }
    }

    return (
        <>
            <Navigation />
            <div id={Styles.signIn}>
                <h2 id={Styles.headlineLogin}><b>Benutzer</b>verwaltung</h2>
                <div id={Styles.input}>
                    <div id="errorBox" />
                    <h6>Passwort</h6>
                    <PasswordField onKeyUp={onKeyUp} state={statePassword} setState={setStatePassword} />
                    <div id={Styles.checkboxContainer}>
                        <CheckBox checked={userData.autoLogOut} state={stateAutoLogOut} setState={setStateAutoLogOut} labelText={"Automatische Abmeldung"} />
                    </div>
                    <button onClick={signIn}>Entsperren</button>
                </div>
            </div>
        </>
    );
}

export default SignIn